export default function Services() {
  const services = [
    {
      icon: 'ri-heart-line',
      title: 'Special Occasions',
      description: 'Make weddings, anniversaries, and celebrations unforgettable with our executive vans. Travel in luxury and comfort with our top-rated Sprinter vans for your most memorable moments.',
      gradient: 'from-rose-400 to-pink-500'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Corporate',
      description: 'Professional transportation for conferences, business meetings, and client transport. Our Sprinters provide a comfortable and professional environment for your corporate needs.',
      gradient: 'from-blue-400 to-indigo-500'
    },
    {
      icon: 'ri-music-line',
      title: 'Entertainment',
      description: 'Premium transportation for concerts, festivals, tailgates, and nights out. Enjoy a comfortable and seamless travel experience with top-tier amenities and plenty of room.',
      gradient: 'from-purple-400 to-violet-500'
    },
    {
      icon: 'ri-sun-line',
      title: 'Vacations',
      description: 'Perfect for families and groups exploring Houston. Our luxury Sprinter vans accommodate up to 10 passengers, making them ideal for road trips and group vacations.',
      gradient: 'from-amber-400 to-orange-500'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial',
      description: 'Reliable Sprinter vans for business purposes. Our fleet is perfect for transporting teams, offering the versatility and professionalism needed for commercial use.',
      gradient: 'from-teal-400 to-cyan-500'
    },
    {
      icon: 'ri-plane-line',
      title: 'Airport Transfers',
      description: 'Professional chauffeur-driven service for IAH, HOU, and local airports. Our drivers ensure timely and comfortable transport for all your airport transfer needs.',
      gradient: 'from-emerald-400 to-green-500'
    }
  ];

  return (
    <section id="services" className="py-20 lg:py-32 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-3">SERVICES</div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Luxury Transportation for Every Occasion
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            From corporate events to special celebrations, our premium Mercedes Maybach Sprinter vans deliver exceptional comfort and style for all your transportation needs throughout Greater Houston.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer group"
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-teal-600 transition-colors">
                {service.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>
              
              <button className="flex items-center space-x-2 text-teal-600 font-semibold text-sm group-hover:space-x-3 transition-all cursor-pointer whitespace-nowrap">
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
